import React from 'react'

interface CardProps {
  card?: string       // e.g. "As", "Kh", "Tc", "9d"
  faceDown?: boolean
  small?: boolean
  className?: string
}

const SUIT_SYMBOLS: Record<string, { symbol: string; label: string; color: string }> = {
  s: { symbol: '♠', label: 's', color: 'text-gray-900' },
  h: { symbol: '♥', label: 'h', color: 'text-red-600' },
  d: { symbol: '♦', label: 'd', color: 'text-red-600' },
  c: { symbol: '♣', label: 'c', color: 'text-gray-900' },
}

const RANK_DISPLAY: Record<string, string> = {
  A: 'A', K: 'K', Q: 'Q', J: 'J', T: '10',
  '9': '9', '8': '8', '7': '7', '6': '6',
  '5': '5', '4': '4', '3': '3', '2': '2',
}

export function Card({ card, faceDown = false, small = false, className = '' }: CardProps) {
  const size = small ? 'w-8 h-11 text-xs' : 'w-12 h-16 text-sm'
  const base = `${size} rounded border border-gray-300 flex flex-col items-center justify-center select-none ${className}`

  if (faceDown || !card) {
    return (
      <div className={`${base} bg-blue-800 border-blue-900`}>
        <div className="text-blue-600 text-lg">♦</div>
      </div>
    )
  }

  const rank = card.slice(0, -1)
  const suit = card.slice(-1).toLowerCase()
  const suitInfo = SUIT_SYMBOLS[suit] ?? { symbol: '?', label: '?', color: 'text-gray-900' }
  const rankDisplay = RANK_DISPLAY[rank] ?? rank

  return (
    <div className={`${base} bg-white`}>
      <span className={`font-bold leading-none ${suitInfo.color} ${small ? 'text-xs' : 'text-base'}`}>
        {rankDisplay}
      </span>
      <span className={`leading-none ${suitInfo.color} ${small ? 'text-xs' : 'text-lg'}`}>
        {suitInfo.symbol}
      </span>
    </div>
  )
}

export function CardPair({
  cards,
  faceDown = false,
  small = false,
}: { cards?: string; faceDown?: boolean; small?: boolean }) {
  const parts = cards?.split(' ').filter(Boolean) ?? []
  const c1 = parts[0]
  const c2 = parts[1]

  return (
    <div className="flex gap-1">
      <Card card={c1} faceDown={faceDown || !c1} small={small} />
      <Card card={c2} faceDown={faceDown || !c2} small={small} />
    </div>
  )
}
